<template>
  <div v-if="isLoggedIn" class="mt-1">
    <v-tabs v-model="active" color="indigo" centered dark slider-color="yellow">
      <v-tab
        v-for="(status, index) in statuses"
        :key="index"
        ripple
        @click="next(status.status_id)"
      >
        {{ status.title }}
      </v-tab>
      <v-tab-item v-for="(status, index) in statuses" :key="index">
        <v-card flat v-if="status.status_id == 1 && active == 0">
          <Pending></Pending>
        </v-card>
        <v-card flat v-else-if="status.status_id == 2 && active == 1">
          <Accepted></Accepted>
        </v-card>
        <v-card flat v-else-if="status.status_id == 3 && active == 2">
          <Rejected></Rejected>
        </v-card>
        <v-card flat v-else-if="status.status_id == 4 && active == 3">
          <Disbursed></Disbursed>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!-- <div class="text-xs-center mt-3">
      <button class="button" flat @click="next">Next Tab</button>
    </div> -->
  </div>
  <div centered v-else>
    <v-container>
      <v-layout row wrap>
        <v-flex xs4 md4></v-flex>
        <v-flex xs4 md4 align-end>
          <v-card>
            <v-card-text color="indigo">You are not logged in!</v-card-text>
          </v-card>
          <router-link to="/signin">
            <v-btn color="#ff2e2e">
              <v-icon>lock_open</v-icon>
              login
            </v-btn>
          </router-link>
        </v-flex>
        <v-flex xs4 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import Pending from "./Pending";
  import Accepted from "./Accepted";
  import Rejected from "./Rejected";
  import Disbursed from "./Disbursed";

  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        active: null,
        statuses: [
          { title: "pending", status_id: 1 },
          { title: "accepted", status_id: 2 },
          { title: "rejected", status_id: 3 },
          { title: "disbursed", status_id: 4 },
        ],
      };
    },
    components: {
      Pending,
      Accepted,
      Rejected,
      Disbursed,
    },
    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
    },

    created() {
      this.statusList(1);
    },

    methods: {
      next(status) {
        this.statusList(status);
        this.active = parseInt(status) - 1;
      },
      statusList: function (withdrawStatusId) {
        // console.log(withdrawStatusId)
        this.$store.dispatch("changeWithdrawStatus", [
          "nagad-cashout-list",
          withdrawStatusId,
          "",
          1,
          10,
        ]);
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .button {
    font-size: 16px;
    background: #ff2e2e;
    padding: 0.4rem 1.3rem;
    text-align: center;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin: 10px;
    color:white;
  }
</style>
